module.exports = __webpack_public_path__ + "static/media/client_detail_img2.265cd7d5.jpg";